/* eslint-disable func-style */
const MaterialReceivingRecord = () => import('../pages/MaterialManage/MaterialReceivingRecord');
const ReceivingRecordDetails = () => import('../pages/MaterialManage/ReceivingRecordDetails');
const MaterialReceiving = () => import('../pages/MaterialManage/MaterialReceiving');
const MaterialRecrivingD = () => import('../pages/MaterialManage/MaterialRecrivingD');
const ImportMaterialReceivingRecord = () => import('../pages/MaterialManage/ImportMaterialReceivingRecord');

const GoodsManage = () => import('../pages/MaterialManage/GoodsManage');
const GoodsReceive = () => import('../pages/MaterialManage/GoodsReceive');
const RightPanel = () => import('../components/RightPanel');

export default [
	{
		path: '/MaterialReceivingRecord',
		name: 'MaterialReceivingRecord',
		component: MaterialReceivingRecord,
		children: [
			{
				path: 'rightPanel',
				name: 'rightPanel',
				component: RightPanel,
				meta: { parent: '/MaterialManage' },
				children: [
					{ // 右滑详情页面
						path: '/ReceivingRecordDetails/:id',
						name: 'ReceivingRecordDetails',
						meta: { parent: '/MaterialManage' },
						component: ReceivingRecordDetails,
					},
				],
			},
		],
	},
	{
		path: '/MaterialReceiving',
		name: 'MaterialReceiving',
		component: MaterialReceiving,
		children: [
			{
				path: 'rightPanelD',
				name: 'rightPanelD',
				component: RightPanel,
				meta: { parent: '/MaterialReceiving' },
				children: [
					{ // 右滑详情页面
						path: '/MaterialRecrivingD/:id',
						name: 'MaterialRecrivingD',
						meta: { parent: '/MaterialManage' },
						component: MaterialRecrivingD,
					},
				],
			},
		],
	},
	{
		path: '/ImportMaterialReceivingRecord',
		name: 'ImportMaterialReceivingRecord',
		component: ImportMaterialReceivingRecord,
	},
	{
		path: '/GoodsManage',
		name: 'GoodsManage',
		component: GoodsManage,
	},
	{
		path: '/GoodsReceive',
		name: '/GoodsReceive',
		component: GoodsReceive,
	},
];
